import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { TPVServices } from "../services";
import { Globals } from "../../../globals";
import { TpvRoomPage } from "../tpv-select/tpv-select";
import { HomePage } from "../../home/home";
import { ConfigurationServices } from '../../configuration/services';
import { TakeawayServices } from '../../takeaway/services';

/**
 * Generated class for the TpvLoaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-loader',
  templateUrl: 'tpv-loader.html',
})
export class TpvLoaderPage {

  first_enter: boolean = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public takeawayServices: TakeawayServices) {

    this.globals.GAtrackView('TPV', 'TPV - Loader', this.globals.restaurant.email, 'View', 'View TPV', 'TPV', '');

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //plg pos
    if (this.globals.restaurant.plg_pos_starter == undefined || this.globals.restaurant.plg_pos_starter == false) {
      this.tpvServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_pos_starter: true,
        plg_pos_finisher: true,
      });
      this.globals.restaurant.plg_pos_starter = true;
      this.globals.restaurant.plg_pos_finisher = true;
      //update hubspot contact
      this.globals.updateERPNextCustomer();
    }
    //limpiar tags al entrar en el loader
    this.tpvServices.dish_tags = Array();
    this.tpvServices.products_tags = Array();
    //Rooms
    this.tpvServices.getRooms(this.globals.restaurant_uid);
    this.tpvServices.getTables(this.globals.restaurant_uid);
    this.tpvServices.getFavouriteMenus(this.globals.restaurant_uid);
    this.tpvServices.getMenus(this.globals.restaurant_uid);
    this.tpvServices.getCombos(this.globals.restaurant_uid);
    this.tpvServices.getFavouriteDishes(this.globals.restaurant_uid);
    this.tpvServices.getDish(this.globals.restaurant_uid);
    this.tpvServices.getFavouriteProducts(this.globals.restaurant_uid);
    this.tpvServices.getProducts(this.globals.restaurant_uid);
    this.tpvServices.getCashs(this.globals.restaurant_uid);
    //Takeaway
    this.takeawayServices.getRooms(this.globals.restaurant_uid);
    this.takeawayServices.getTablesTakeaway(this.globals.restaurant_uid);
    this.takeawayServices.getFavouriteMenus(this.globals.restaurant_uid);
    this.takeawayServices.getMenus(this.globals.restaurant_uid);
    this.takeawayServices.getCombos(this.globals.restaurant_uid);
    this.takeawayServices.getFavouriteDishes(this.globals.restaurant_uid);
    this.takeawayServices.getDish(this.globals.restaurant_uid);
    this.takeawayServices.getFavouriteProducts(this.globals.restaurant_uid);
    this.takeawayServices.getProducts(this.globals.restaurant_uid);
    this.takeawayServices.getCashs(this.globals.restaurant_uid);
    this.takeawayServices.checkChangesTables(this.globals.restaurant_uid);
    this.configurationServices.getRestaurant(this.globals.restaurant_uid);
    //this.configurationServices.getLast5Tickets(this.globals.restaurant_uid);
    this.takeawayServices.checkGirona();
    loadingPopup.dismiss();
    this.navCtrl.setRoot(TpvRoomPage);

  }

  ionViewDidLoad() {

  }

  ionViewCanEnter() {
    if (this.first_enter) {
      this.first_enter = false;
    } else {
      this.globals.side_menu_active = 'dashboard';
      this.navCtrl.setRoot(HomePage);
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-loader/tpv-loader.ts